module.exports = __webpack_public_path__ + "front/img/home-kv.8af64a50.png";